import { connect } from 'react-redux'
import { openLoginModal } from '../../actions/modals'
import LoginBlock from './LoginBlock'

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        openLoginModal: (data) => {
            dispatch(openLoginModal(data))
        },
    }
}

const LoginBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginBlock)

export default LoginBlockContainer
